module.exports = __webpack_public_path__ + "static/img/pk_defult.6310fad4.png";